import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { ClientPortalApiService } from '../../services/client-portal-api.service';
import { AuthStateService } from '@hypenation/auth';
import { CheckInRecord } from '../../models/client-portal.models';
import { PaginationResponse } from '@hypenation/tickets';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'hypenation-check-in-history',
  standalone: true,
  imports: [
    CommonModule,
    NzTableModule,
    NzTagModule,
    NzCardModule,
    NzPaginationModule,
    NzSpinModule,
  ],
  templateUrl: './check-in-history.component.html',
  styleUrl: './check-in-history.component.css',
})
export class CheckInHistoryComponent implements OnInit {
  loading = false;
  records: CheckInRecord[] = [];
  totalItems = 0;
  pageSize = 10;
  pageIndex = 1;
  userEmail: string | null = null;

  private readonly apiService = inject(ClientPortalApiService);
  private readonly authStateService = inject(AuthStateService);

  ngOnInit(): void {
    this.userEmail = this.authStateService.getUserEmail();
    if (this.userEmail) {
      this.loadCheckIns();
    }
  }

  loadCheckIns(): void {
    if (!this.userEmail) return;
    this.loading = true;
    this.apiService
      .getMyCheckins(this.userEmail, this.pageIndex - 1, this.pageSize)
      .subscribe({
        next: (res: HttpResponse<PaginationResponse<CheckInRecord[]>>) => {
          this.records = res.body?.content ?? [];
          this.totalItems = res.body?.totalElements ?? 0;
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.loadCheckIns();
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
